import React from 'react';
import {useSession} from "../providers/UseSession";
import {Navigate} from "react-router-dom";

interface Props {
    children: JSX.Element
}

const PublicRoute: React.FC<Props> = ({children}) => {
    const {isAuth} = useSession();
    return !isAuth ? children : <Navigate to={'/app/dashboard'}/>
};

export default PublicRoute;
